import React, { useEffect, useState } from 'react'
import BackButton from '../components/BackButton'
import { handleRedirect } from '../Script'
import {getCachedData} from '../Firebase'

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'swiper/css';

export default function Streaming() {

    const [avatarsList, setAvatarsList] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    function getFirstTwoWords(str) {
        return str.split('_').slice(0, 2).join(' ');
    }


    useEffect(() => {
        setIsLoading(true)
        // getStreaming().then((photos) => {
        //     setAvatarsList(photos)
        //     setIsLoading(false)

        // })
        getCachedData('streaming_avatars').then((photos) => {
            setAvatarsList(photos)
            setIsLoading(false)

        })
    }, [])


    return (
        <>
            <div className=' pt-4 ' style={{ marginBottom: "12rem" }} >

                <div className='container' data-aos='fade-down'>
                    <BackButton title="Streaming" />
                </div>


                <div className='container mt-6' >
                    <h1 className='mb-2'>Choose your Streaming Avatar</h1>

                    <div className='photo-grid' data-aos='fade-up'>
                        {isLoading ? (
                            // Show skeletons while loading
                            Array(6)
                                .fill(0)
                                .map((_, index) => (
                                    <div key={index} className='skeleton-square'></div>
                                ))
                        ) : avatarsList && avatarsList.length > 0 ? (
                            // Show images when loaded
                            avatarsList.map((photo, index) => (
                                <div       key={index} >
                                    <LazyLoadImage
                              
                                    onClick={() => handleRedirect(photo, 'streaming')}
                                    src={photo.preview_image_url}
                                    alt={`Photo ${index}`}
                                    loading='lazy'
                                />
                                <h2 className='pt-2'>{getFirstTwoWords(photo.avatar_id)}</h2>
                                </div>
                            ))
                        ) : (
                            // Fallback when no photos are available
                            ""
                        )}
                    </div>




                    {/* 
                    <div className='photo-grid' data-aos='fade-up' >

                        {avatarsList ? avatarsList.map((photo, index) => (
                            <img key={index} onClick={() => handleRedirect(photo, "talking_photo")}
                                src={photo.preview_image_url} />

                        )) : ""}




                    </div> */}




                </div>
            </div>
        </>
    )
}
